import { Text, type ImageProps } from "@hopper-ui/components";
import type { PropsWithChildren, ReactElement } from "react";

import { Div, Flex } from "@hopper-ui/components";
import "./Channel.css";

interface Props {
    icon: ReactElement<Partial<ImageProps>>;
    title: string;
}

export const Channel = ({ icon, title, children }: PropsWithChildren<Props>) => {
    return (
        <Div
            borderBottom="neutral-weakest"
            padding="inset-md"
        >
            <Flex direction="column" gap="inline-sm">
                <Flex alignItems="center" gap="inline-sm" className="wai-channel-header">
                    {icon}
                    <Text size="xs" fontWeight="body-xs-semibold" color="neutral">
                        {title}
                    </Text>
                </Flex>
                {children}
            </Flex>
        </Div>
    );
};
